(function () {
    function init(root) {
    if (root.dataset.wbsProductReady === 'true') return;
    root.dataset.wbsProductReady = 'true';

    var dataEl = root.querySelector('[data-wbs-variants]');
    var variants = [];
    if (dataEl) {
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (error) {
        variants = [];
      }
    }

    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-wbs-price] bdi');
    var stockEl = root.querySelector('[data-wbs-stock]');
    var addToCart = root.querySelector('add-to-cart-component');
    var addToCartButton = root.querySelector('[ref="addToCartButton"]');
    var addToCartLabel = sectionButtonLabel(root);
    var threshold = parseInt(root.dataset.lowStock || '4', 10);
    var cleanups = [];

    function onTeardown() {
      cleanups.forEach(function (fn) {
        try {
          fn();
        } catch (error) {}
      });
      cleanups = [];
      delete root.dataset.wbsProductReady;
    }

    root.addEventListener('wbs:product:teardown', onTeardown);

    function sectionButtonLabel(el) {
      var btn = el.querySelector('.wbs-product__add');
      if (!btn) return 'Add To Bag';
      var content = btn.querySelector('.add-to-cart-text__content');
      if (content) {
        return (content.textContent || '').replace(/\s+/g, ' ').trim() || 'Add To Bag';
      }
      var clone = btn.cloneNode(true);
      var added = clone.querySelector('.add-to-cart__added');
      if (added) added.remove();
      var text = (clone.textContent || '').replace(/\s+/g, ' ').trim();
      return text || 'Add To Bag';
    }

    function selectedOptions() {
      return Array.from(root.querySelectorAll('[data-wbs-option]')).map(function (group) {
        var active = group.querySelector('[data-wbs-swatch].is-active');
        return active ? active.dataset.value : '';
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price == null ? '' : String(variant.price);
      if (typeof window.WbsLowInventoryUpdate === 'function') {
        window.WbsLowInventoryUpdate(root, variant.id);
      } else if (stockEl) {
        var show = variant.tracked && variant.qty > 0 && variant.qty <= threshold;
        stockEl.hidden = !show;
        if (show) stockEl.textContent = 'Only ' + variant.qty + ' Left';
      }
      if (addToCart) {
        if (variant.featured_image) {
          addToCart.setAttribute('data-product-variant-media', variant.featured_image);
        } else {
          addToCart.removeAttribute('data-product-variant-media');
        }
      }
      if (addToCartButton) {
        addToCartButton.disabled = !variant.available;
        var nextLabel = variant.available ? addToCartLabel : 'Sold out';
        var labelContent = addToCartButton.querySelector('.add-to-cart-text__content');
        if (labelContent) {
          labelContent.textContent = nextLabel;
        } else {
          var labelNode = null;
          for (var i = 0; i < addToCartButton.childNodes.length; i++) {
            if (addToCartButton.childNodes[i].nodeType === 3) {
              labelNode = addToCartButton.childNodes[i];
              break;
            }
          }
          if (labelNode) labelNode.textContent = nextLabel;
        }
      }
      root.querySelectorAll('[data-wbs-option]').forEach(function (group, index) {
        var label = group.querySelector('[data-wbs-option-label]');
        if (!label) return;
        var value = variant.options[index] || '';
        var name = group.dataset.optionName || '';
        label.textContent = index === 0 ? value : 'Selected ' + name + ': ' + value;
      });
    }

    root.querySelectorAll('[data-wbs-swatch]').forEach(function (button) {
      button.addEventListener('click', function () {
        var group = button.closest('[data-wbs-option]');
        group.querySelectorAll('[data-wbs-swatch]').forEach(function (swatch) {
          swatch.classList.remove('is-active');
          swatch.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        var options = selectedOptions();
        var match = variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === options[index];
          });
        });
        applyVariant(match);
      });
    });

    initGallery(root, cleanups);
    initDetails(root);
  }

  function initDetails(root) {
    var details = Array.from(root.querySelectorAll('[data-wbs-detail]'));
    if (!details.length) return;

    var stacked = window.matchMedia('(max-width: 1199.98px)');
    var holdFrame = 0;
    var holding = false;
    var anchorLocked = false;
    var cancelTouch = null;

    function panelAnim(detail) {
      return detail.querySelector('.wbs-product__panel-anim');
    }

    function hidePanelAnim(detail) {
      var anim = panelAnim(detail);
      if (!anim || detail.classList.contains('is-open')) return;

      if (stacked.matches) {
        anim.inert = true;
        anim.removeAttribute('hidden');
        return;
      }

      var done = function (event) {
        if (event && event.target !== anim) return;
        if (
          event &&
          event.propertyName !== 'max-height' &&
          event.propertyName !== 'opacity'
        ) {
          return;
        }
        anim.setAttribute('hidden', '');
        anim.removeEventListener('transitionend', done);
      };

      anim.addEventListener('transitionend', done);
      window.setTimeout(function () {
        if (!detail.classList.contains('is-open')) {
          anim.setAttribute('hidden', '');
        }
      }, 480);
    }

    function showPanelAnim(detail) {
      var anim = panelAnim(detail);
      if (!anim) return;
      anim.inert = false;
      anim.removeAttribute('hidden');
      void anim.offsetHeight;
    }

    function syncClosed() {
      details.forEach(function (detail) {
        var anim = panelAnim(detail);
        if (!anim) return;
        if (detail.classList.contains('is-open')) {
          anim.inert = false;
          anim.removeAttribute('hidden');
          return;
        }
        if (stacked.matches) {
          anim.inert = true;
          anim.removeAttribute('hidden');
        } else {
          anim.inert = false;
          anim.setAttribute('hidden', '');
        }
      });
    }

    syncClosed();
    stacked.addEventListener('change', syncClosed);

    function readScroll() {
      var page = document.querySelector('.page-wrapper');
      if (page && page.scrollHeight > page.clientHeight + 2) return page.scrollTop;
      return window.scrollY || document.documentElement.scrollTop || 0;
    }

    function writeScroll(value) {
      var page = document.querySelector('.page-wrapper');
      if (page && page.scrollHeight > page.clientHeight + 2) {
        if (window.lenis && typeof window.lenis.resize === 'function') window.lenis.resize();
        if (window.lenis && typeof window.lenis.scrollTo === 'function') {
          window.lenis.scrollTo(value, { immediate: true, force: true });
          return;
        }
        page.scrollTop = value;
        return;
      }
      window.scrollTo(0, value);
    }

    var pinTimer = 0;
    var pinStop = 0;

    function pinSummary(summary, anchorTop) {
      var drift = summary.getBoundingClientRect().top - anchorTop;
      if (Math.abs(drift) > 0.5) writeScroll(readScroll() + drift);
    }

    /* Desktop columns overlap, so closing one changes the row height after
       the panel leaves the layout. Keep the tapped header still until then. */
    function holdSummary(summary, anchorTop) {
      if (pinTimer) window.clearInterval(pinTimer);
      if (pinStop) window.clearTimeout(pinStop);
      pinSummary(summary, anchorTop);
      pinTimer = window.setInterval(function () {
        pinSummary(summary, anchorTop);
      }, 16);
      pinStop = window.setTimeout(function () {
        window.clearInterval(pinTimer);
        pinTimer = 0;
        pinSummary(summary, anchorTop);
      }, 800);
    }

    function scrollport() {
      var page = document.querySelector('.page-wrapper');
      if (page) {
        var overflow = window.getComputedStyle(page).overflowY;
        if ((overflow === 'auto' || overflow === 'scroll') && page.scrollHeight > page.clientHeight + 2) {
          return page;
        }
      }
      return document.scrollingElement || document.documentElement;
    }

    function nativeScrollTop(scroller) {
      if (scroller === document.scrollingElement || scroller === document.documentElement) {
        return window.scrollY || scroller.scrollTop || 0;
      }
      return scroller.scrollTop;
    }

    function nativeScrollTo(scroller, value) {
      var next = Math.max(0, Math.round(value));
      if (scroller === document.scrollingElement || scroller === document.documentElement) {
        var root = document.scrollingElement || document.documentElement;
        var previous = root.style.scrollBehavior;
        root.style.scrollBehavior = 'auto';
        root.scrollTop = next;
        root.style.scrollBehavior = previous;
        return;
      }
      scroller.scrollTop = next;
    }

    function layoutTop(node, scroller) {
      var top = 0;
      var el = node;
      while (el && el !== scroller) {
        top += el.offsetTop || 0;
        el = el.offsetParent;
      }
      return top;
    }

    function lockAnchor() {
      document.documentElement.style.overflowAnchor = 'none';
      if (document.body) document.body.style.overflowAnchor = 'none';
      anchorLocked = true;
    }

    function unlockAnchor() {
      if (!anchorLocked) return;
      document.documentElement.style.overflowAnchor = '';
      if (document.body) document.body.style.overflowAnchor = '';
      anchorLocked = false;
      if (window.lenis && typeof window.lenis.resize === 'function') window.lenis.resize();
    }

    function stopHold() {
      holding = false;
      if (holdFrame) window.cancelAnimationFrame(holdFrame);
      holdFrame = 0;
      if (cancelTouch) {
        window.removeEventListener('touchstart', cancelTouch);
        cancelTouch = null;
      }
      unlockAnchor();
    }

    /* Phone and tablet scroll natively. Lenis still clamps scrollTo() to a
       limit that lags behind the opening panel, and reading the visual
       viewport fights the iOS toolbar. Follow layout position only. */
    function holdStacked(summary, scroller, anchor) {
      if (holdFrame) window.cancelAnimationFrame(holdFrame);
      if (cancelTouch) window.removeEventListener('touchstart', cancelTouch);
      holding = true;
      var started = performance.now();

      function finish() {
        if (!holding) return;
        stopHold();
      }

      cancelTouch = function () {
        finish();
      };
      window.addEventListener('touchstart', cancelTouch, { passive: true });

      function frame() {
        if (!holding) return;
        var drift = layoutTop(summary, scroller) - nativeScrollTop(scroller) - anchor;
        if (Math.abs(drift) >= 1) nativeScrollTo(scroller, nativeScrollTop(scroller) + drift);
        if (performance.now() - started < 520) {
          holdFrame = window.requestAnimationFrame(frame);
        } else {
          finish();
        }
      }

      holdFrame = window.requestAnimationFrame(frame);
    }

    function onTeardown() {
      stopHold();
      stacked.removeEventListener('change', syncClosed);
      root.removeEventListener('wbs:product:teardown', onTeardown);
    }

    root.addEventListener('wbs:product:teardown', onTeardown);

    details.forEach(function (detail) {
      var summary = detail.querySelector('.wbs-product__summary');
      if (!summary) return;

      summary.addEventListener('mousedown', function (event) {
        if (stacked.matches) event.preventDefault();
      });

      summary.addEventListener('click', function () {
        var isOpen = detail.classList.contains('is-open');
        var useStack = stacked.matches;
        var anchorTop = summary.getBoundingClientRect().top;
        var scroller = scrollport();
        var stackAnchor = layoutTop(summary, scroller) - nativeScrollTop(scroller);

        if (useStack) lockAnchor();

        details.forEach(function (item) {
          if (item.classList.contains('is-open')) {
            item.classList.remove('is-open');
            hidePanelAnim(item);
          } else {
            item.classList.remove('is-open');
          }
          var btn = item.querySelector('.wbs-product__summary');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });

        if (!isOpen) {
          if (useStack) {
            var anim = panelAnim(detail);
            if (anim) {
              anim.inert = false;
              anim.removeAttribute('hidden');
            }
            detail.classList.add('is-open');
            summary.setAttribute('aria-expanded', 'true');
          } else {
            showPanelAnim(detail);
            window.requestAnimationFrame(function () {
              detail.classList.add('is-open');
              summary.setAttribute('aria-expanded', 'true');
            });
          }
        }

        if (useStack) holdStacked(summary, scroller, stackAnchor);
        else holdSummary(summary, anchorTop);
      });
    });
  }

  function initGallery(root, parentCleanups) {
    var pin = root.querySelector('[data-wbs-pin]');
    var sticky = root.querySelector('[data-wbs-sticky]');
    var track = root.querySelector('[data-wbs-track]');
    if (!pin || !sticky || !track) return;

    var wide = window.matchMedia('(min-width: 810px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;
    var scrollbar = pin.querySelector('[data-wbs-scrollbar]');
    var scrollbarThumb = pin.querySelector('[data-wbs-scrollbar-thumb]');
    var scrollbarTimer = 0;
    var scrollbarEngaged = false;
    var dragActive = false;
    var dragPointerId = null;
    var dragStartX = 0;
    var dragOrigin = 0;
    var dragX = null;
    var overrideX = null;

    function galleryOverflow() {
      return Math.max(0, track.scrollWidth - sticky.clientWidth);
    }

    function clampOffset(value, max) {
      if (value < 0) return 0;
      if (value > max) return max;
      return value;
    }

    function revealLimit() {
      var raw = parseInt(root.getAttribute('data-wbs-gallery-reveal'), 10);
      if (isNaN(raw) || raw < 1) return 0;
      return raw;
    }

    function cappedOverflow() {
      var full = galleryOverflow();
      var limit = revealLimit();
      if (!limit || full <= 1) return full;

      var slides = track.querySelectorAll('.wbs-product__slide');
      var visible = [];
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetWidth > 0) visible.push(slides[i]);
      }
      if (visible.length <= limit) return full;

      var slide = visible[limit - 1];
      var end = slide.offsetLeft + slide.offsetWidth - sticky.clientWidth;
      if (end < 0) end = 0;
      if (end > full) end = full;
      return end;
    }

    function linkedOffset() {
      var cap = cappedOverflow();
      if (cap <= 1) return 0;
      var traveled = -pin.getBoundingClientRect().top;
      if (traveled < 0) return 0;
      if (traveled > cap) return cap;
      return traveled;
    }

    function scrollByDelta(deltaY) {
      if (!deltaY) return;
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(window.lenis.scroll + deltaY);
        return;
      }
      var page = document.querySelector('.page-wrapper');
      if (page) {
        page.scrollTop += deltaY;
      } else {
        window.scrollBy(0, deltaY);
      }
    }

    function scrollPageToOffset(targetX) {
      var deltaY = targetX - linkedOffset();
      if (Math.abs(deltaY) < 0.5) return;
      scrollByDelta(deltaY);
    }

    function update() {
      ticking = false;
      if (!wide.matches || reduce.matches) {
        pin.style.height = '';
        track.style.transform = '';
        overrideX = null;
        return;
      }

      var full = galleryOverflow();
      var cap = cappedOverflow();
      if (full <= 1) {
        pin.style.height = '';
        track.style.transform = '';
        overrideX = null;
        return;
      }

      pin.style.height = sticky.offsetHeight + cap + 'px';
      var linked = linkedOffset();
      var x;
      if (dragX !== null) {
        x = dragX;
      } else if (overrideX !== null) {
        if (linked < 1) {
          overrideX = null;
          x = linked;
        } else {
          x = overrideX;
        }
      } else {
        x = linked;
      }
      track.style.transform = 'translate3d(' + -clampOffset(x, full) + 'px,0,0)';
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function layoutScrollbar() {
      if (!scrollbar || !scrollbarThumb) return;
      if (wide.matches) {
        scrollbar.classList.remove('is-active');
        return;
      }

      var max = sticky.scrollWidth - sticky.clientWidth;
      if (max <= 1) {
        scrollbar.classList.remove('is-active');
        return;
      }

      var trackWidth = pin.clientWidth;
      var thumbWidth = trackWidth * (sticky.clientWidth / sticky.scrollWidth);
      var travel = Math.max(0, trackWidth - thumbWidth);
      var progress = sticky.scrollLeft / max;
      scrollbarThumb.style.width = thumbWidth + 'px';
      scrollbarThumb.style.transform = 'translate3d(' + progress * travel + 'px,0,0)';
    }

    function showScrollbar() {
      if (!scrollbar || wide.matches || !scrollbarEngaged) return;
      layoutScrollbar();
      if (sticky.scrollWidth - sticky.clientWidth <= 1) return;
      scrollbar.classList.add('is-active');
      window.clearTimeout(scrollbarTimer);
      scrollbarTimer = window.setTimeout(function () {
        scrollbar.classList.remove('is-active');
      }, 700);
    }

    function engageScrollbar() {
      scrollbarEngaged = true;
    }

    var cleanups = [];
    var boundLenis = null;

    function listen(target, type, fn, options) {
      target.addEventListener(type, fn, options);
      cleanups.push(function () {
        target.removeEventListener(type, fn, options);
      });
    }

    function unbindLenis() {
      if (!boundLenis) return;
      boundLenis.off('scroll', requestUpdate);
      boundLenis = null;
    }

    function bindLenis() {
      if (!window.lenis || boundLenis === window.lenis) return;
      unbindLenis();
      boundLenis = window.lenis;
      window.lenis.on('scroll', requestUpdate);
    }

    listen(window, 'scroll', requestUpdate, { passive: true });
    listen(window, 'resize', function () {
      requestUpdate();
      layoutScrollbar();
    });
    listen(wide, 'change', function () {
      dragActive = false;
      dragPointerId = null;
      dragX = null;
      overrideX = null;
      sticky.classList.remove('is-wbs-dragging');
      requestUpdate();
      layoutScrollbar();
    });
    listen(reduce, 'change', requestUpdate);
    listen(sticky, 'pointerdown', engageScrollbar);

    function onGalleryPointerDown(event) {
      if (!wide.matches || reduce.matches || event.button !== 0) return;
      var overflow = galleryOverflow();
      if (overflow <= 1) return;

      dragActive = true;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragOrigin = dragX !== null ? dragX : overrideX !== null ? overrideX : linkedOffset();
      sticky.classList.add('is-wbs-dragging');
      if (sticky.setPointerCapture) {
        sticky.setPointerCapture(event.pointerId);
      }
    }

    function onGalleryPointerMove(event) {
      if (!dragActive || event.pointerId !== dragPointerId) return;
      var overflow = galleryOverflow();
      if (overflow <= 1) return;

      var deltaX = event.clientX - dragStartX;
      dragX = clampOffset(dragOrigin - deltaX, overflow);
      requestUpdate();
      event.preventDefault();
    }

    function endGalleryDrag(event) {
      if (!dragActive || (event && event.pointerId !== dragPointerId)) return;

      var finalX = dragX;
      dragActive = false;
      dragPointerId = null;
      dragX = null;
      sticky.classList.remove('is-wbs-dragging');
      if (sticky.releasePointerCapture && event && event.pointerId != null) {
        try {
          sticky.releasePointerCapture(event.pointerId);
        } catch (error) {
          /* pointer already released */
        }
      }

      if (finalX !== null) {
        var cap = cappedOverflow();
        if (finalX > cap + 1) {
          overrideX = finalX;
        } else {
          overrideX = null;
          scrollPageToOffset(finalX);
        }
      }
      requestUpdate();
    }

    listen(sticky, 'pointerdown', onGalleryPointerDown);
    listen(sticky, 'pointermove', onGalleryPointerMove);
    listen(sticky, 'pointerup', endGalleryDrag);
    listen(sticky, 'pointercancel', endGalleryDrag);
    listen(sticky, 'lostpointercapture', endGalleryDrag);
    listen(
      track,
      'dragstart',
      function (event) {
        event.preventDefault();
      },
      false
    );

    listen(
      sticky,
      'wheel',
      function (event) {
        engageScrollbar();
        if (!wide.matches || reduce.matches) return;

        var overflow = galleryOverflow();
        if (overflow <= 1) return;

        var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (!horizontal || !event.deltaX) return;

        event.preventDefault();
        var cap = cappedOverflow();
        var current = overrideX !== null ? overrideX : linkedOffset();
        var next = clampOffset(current + event.deltaX, overflow);
        if (next > cap + 1) {
          overrideX = next;
          requestUpdate();
        } else {
          overrideX = null;
          scrollPageToOffset(next);
        }
      },
      { passive: false }
    );
    listen(sticky, 'scroll', function () {
      layoutScrollbar();
      showScrollbar();
    }, { passive: true });
    var page = document.querySelector('.page-wrapper');
    if (page) listen(page, 'scroll', requestUpdate, { passive: true });
    listen(document, 'wbs:lenis', bindLenis);

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        listen(img, 'load', function () {
          requestUpdate();
          layoutScrollbar();
        });
      }
    });

    function onUnload(event) {
      if (!event.target.contains(root)) return;
      window.clearTimeout(scrollbarTimer);
      unbindLenis();
      cleanups.forEach(function (remove) {
        remove();
      });
      document.removeEventListener('shopify:section:unload', onUnload);
    }

    document.addEventListener('shopify:section:unload', onUnload);
    bindLenis();
    requestUpdate();
    layoutScrollbar();

    if (parentCleanups) {
      parentCleanups.push(function () {
        window.clearTimeout(scrollbarTimer);
        unbindLenis();
        cleanups.forEach(function (remove) {
          remove();
        });
        document.removeEventListener('shopify:section:unload', onUnload);
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-wbs-product]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
